import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import makeStyles from '@mui/styles/makeStyles';
import { lineFontStyles } from 'src/constants';

const useStyles = makeStyles((theme: Theme) => ({
  tableCard: {
    width: '100%',
    margin: '30px',
    padding: '10px',
  },

  tableRow: {
    '& td, & th': {
      border: 0,
    },
  },
  tableCell: {
    [`&.${tableCellClasses.head}`]: {
      color: alpha(theme.palette.common.white, 0.4),
    },
    [`&.${tableCellClasses.body}`]: {
      color: theme.palette.common.white,
    },
  },
  formCard: {
    width: '82%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '20px auto',
    padding: '15px',
    height: 'max-content',
  },
  cardTitle: {
    marginBottom: '5px',
    color: theme.palette.text.disabled,
  },
  halfWidth: {
    width: '48%',

    '&>*': {
      width: '100%',
    },
  },
  fullWidth: {
    width: '100%',
  },
  input: {
    width: '100%',
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
  },
  selectBox: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
    '& .MuiInput-underline:before': {
      borderBottom: '0',
    },
  },
  permission: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  groupPermissions: {
    maxHeight: '300px',
    overflowY: 'scroll',
  },
  cancelSaveButtons: {
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  cancelAddButtons: {
    marginBottom: '30px',
    padding: '50px 20px 10px 10px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  groupPermissionWrapper: {
    width: '100%',
    marginBottom: '20px',
  },
  groupPermissionItem: {
    width: '100%',
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
    borderRadius: '5px',
    padding: '10px 15px',
  },
  groupPermissionItemTop: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  groupPermissionItemTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  groupPermissionItemRemoveButton: {
    textDecoration: 'underline',
  },
  checkBoxFormControl: {
    '& .MuiFormControlLabel-label': {
      color: theme.palette.text.primary,
    },
  },
  cancelIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[100],
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
  deleteIcon: {
    cursor: 'pointer',
    opacity: 0.7,
    '&:hover': {
      opacity: 1,
    },
  },
  addedContentItem: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    //height: '40px',
    fontSize: lineFontStyles.fontSize,
    lineHeight: lineFontStyles.lineHeight,
  },
  permissionContainer: {
    height: '300px',
    overflowY: 'scroll',
    backgroundColor: theme.palette.grey[500],
    borderRadius: '5px',
    padding: '0px 15px 10px 15px',
  },
  permissionSearchBox: {
    position: 'sticky',
    top: 0,
    paddingTop: '10px',
    backgroundColor: theme.palette.grey[500],
  },
  permissionListContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '300px',
    // overflowY: 'scroll',
  },
  searchInput: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: '5px',
    width: '100%',
    marginBottom: '10px',
    padding: '5px 7px',
  },
  groupUsersContainer: {
    //height: '400px',
    //overflowY: 'scroll',
  },
  headerContainer: {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1001,
  },
  permissionListItem: {
    cursor: 'pointer',
    fontSize: lineFontStyles.fontSize,
    lineHeight: lineFontStyles.lineHeight,
  },
  cancelAddButton: {
    margin: '0 0 10px 0',
  },
}));

export default useStyles;
